import React, { useContext, useState } from "react";
import Navbar from "../../../../common/layout/Navbar";
import {
  empType,
  LicenseTypes,
  Operation,
} from "../../../../../utils/Enum.types";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import ParticularProjectDetails from "./ParticularProjectDetails";
import { Title } from "../../../../../stories/Title/Title";
import WorkProgressTable from "./WorkProgressTable";
import { CustomDrawer } from "../../../../../styles/CustomDrawerStyles";
import FillRemarks from "./FillRemarks";
import { AppContext } from "../../../../../context/context";
import FillProgressDetails from "./FillProgressDetails";

const ViewProjectDetails = () => {
  const navigate = useNavigate();
  const [remarks, setRemarks] = useState(false);
  const [fillWorkProgress, setFillWorkProgress] = useState(false);

  const { state } = useContext(AppContext);
  return (
    <>
      <Navbar NavType={LicenseTypes.DASHBOARD} />
      <Title>Work Progress</Title>
      <div className="wp-project-details">
        <ParticularProjectDetails />{" "}
        <div className="wp-project-details__block">
          <WorkProgressTable />
        </div>
        {state.empSubType === empType.PMU ? (
          <Button mode="addnew" onClick={() => setRemarks(!remarks)}>
            {" "}
            Remarks
          </Button>
        ) : null}
        {state.empSubType === empType.VENDOR_MANAGER ? (
          <Button
            mode="addnew"
            onClick={() => {
              setFillWorkProgress(true);
            }}
          >
            {" "}
            Fields Data
          </Button>
        ) : null}
        <Button
          mode="back"
          onClick={(e: any) => {
            e.preventDefault();
            navigate(-1);
          }}
        />
      </div>
      <CustomDrawer
        anchor="right"
        open={remarks}
        onClose={() => setRemarks(!remarks)}
      >
        <FillRemarks
          setDrawer={setRemarks}
          operation={Operation.CREATE}
          AtsProjectDailyReportsID={0}
        />
      </CustomDrawer>
      <CustomDrawer
        anchor="right"
        open={fillWorkProgress}
        onClose={() => setFillWorkProgress(!fillWorkProgress)}
      >
        <FillProgressDetails
          setDrawer={setFillWorkProgress}
          operation={Operation.CREATE}
          reportsID={0}
        />
      </CustomDrawer>
    </>
  );
};

export default ViewProjectDetails;
